<div class="cf-main-container">
    <mat-card oneCard class="cf-one-card">
        <mat-card-title>
            <span class="mat-title">Configure feedback form</span>
            <mat-slide-toggle [(ngModel)]="feedbackEnabled" (change)="updateFBEnabled($event.checked)" style="font-size: 16px; margin-block: 16px; display: block;">
                Enabled
            </mat-slide-toggle>
            <p *ngIf="feedbackEnabled">Click on "Add feedback option" to add a new feedback option</p>
        </mat-card-title>
        <mat-card-content *ngIf="!feedbackEnabled">
            The notification will not collect feedback and no Confirm button will be shown to the customer contact.
        </mat-card-content>
        <mat-card-content *ngIf="feedbackEnabled">
            <dl-cf-feedback-template [isNewFromTemplate]="isNewFromTemplate" [addRowData]="updateFeedbackOptions" [displayedColumns]="templateColumn" [tableData]="templateData" *ngIf="templateData.length > 0" (isFeedbackOptionAdded)="feedbackOptionAdded($event)" (feedbackAddedChange)="onFeedbackAdded($event)" #temp></dl-cf-feedback-template>          
        </mat-card-content>
        <mat-card-actions>
            <!-- [disabled]="isAfoBtnDisabled" -->
            <button style="display:none;" (click)="btnTemplatesClicked()" [disabled]="ischeckforTemplate" mat-stroked-button one-secondary-button>
                Templates
            </button>
            
            <div class="cf-dropdown-button">
                <mat-action-list oneList *ngIf="isAfoBtnExpanded">
                    <button (click)="newFeedbackClicked('clicked')" mat-list-item>New</button>
                    <mat-divider></mat-divider>
                    <!-- [disabled]="isAfoBtnDisabled" -->
                    <button style="display: none;" (click)="chooseFromTemplateClicked()" [disabled]="ischeckforTemplate" mat-list-item>Choose from templates</button>
                    <mat-divider></mat-divider>
                </mat-action-list>
                <button *ngIf="feedbackEnabled" (click)="btnAfoClicked()" [disabled]="isAfoBtnDisabled" [class.btn-expanded]="isAfoBtnExpanded" class="btn-add-feedback" mat-stroked-button one-secondary-button>
                    <span>Add feedback option</span>
                </button>
            </div>
        </mat-card-actions>
    </mat-card>
</div>
